/**
 * Chip Component - Template
 * ==========================
 */

export const CHIP_TEMPLATE: string = `
<span class="ec-chip" ng-class="$ctrl.getChipClasses()">
  <span
    ng-if="$ctrl.showIcon"
    class="ec-flex-shrink-0"
    ng-class="$ctrl.getIconClasses()"
    ng-bind-html="$ctrl.trustedIcon"
    aria-hidden="true"
  ></span>
  <span ng-if="$ctrl.hasContent" ng-class="$ctrl.getLabelClasses()" ng-transclude></span>
  <span ng-if="!$ctrl.hasContent" ng-class="$ctrl.getLabelClasses()">{{ $ctrl.text }}</span>
  <button
    ng-if="$ctrl.dismissible"
    type="button"
    ng-class="$ctrl.getDismissClasses()"
    ng-click="$ctrl.handleDismiss($event)"
    ng-bind-html="$ctrl.trustedDismissIcon"
    aria-label="Quitar"
  ></button>
</span>
`;

export default CHIP_TEMPLATE;
